function clearInput(input){
    if (isNaN(parseInt(input.value))) {
        input.value = "";
    }
}

var calculateArray = new Array('m','m','m','m','m','m','m');
function setCaculate(type, id) {
    calculateArray[id] = type;

    /*CHANGE LES PLACEHOLDER POUR METRES OU PIED EN GARDANT LINFO DANS LE DATA (LONGEUR,LARGEUR,HAUTEUR)*/
    if(type=='m'){

        $('.result').each(function(){
          $(this).find('p span.metrique').css('display','block');
          $(this).find('p span.imperial').css('display','none');
        });

        $('.values input[type=number]').each(function(){
            $(this).closest('.values-item-inner_length').find('label span').html($(this).attr('data-mesure')+' / m'+decodeURI("%C3%A8")+'tres');
            $(this).closest('.values-item-inner_thickness').find('label span').html($(this).attr('data-mesure')+' / Centim'+decodeURI("%C3%A8")+'tres ');


            /*if volume*/
            // if($('.result_currency').attr('data-mesure')=='cubes'){
            //     $('.result_currency_imp').text('tonnes m'+decodeURI("%c3%a9")+'triques' );
            // }else{
            //     $('.result_currency').text('Verges carr'+decodeURI("%c3%a9")+'s');
            // }
        });
    }else{

      $('.result').each(function(){
        $(this).find('p span.metrique').css('display','none');
        $(this).find('p span.imperial').css('display','block');
      });
        $('.values input[type=number]').each(function(){
            $(this).closest('.values-item-inner_length').find('label span').html($(this).attr('data-mesure')+' / Pieds');
            $(this).closest('.values-item-inner_thickness').find('label span').html($(this).attr('data-mesure')+' / pouces');
        });
        /*if volume*/
        // if($('.result_currency').attr('data-mesure')=='cubes'){
        //     //$('.result_currency').text('verges cubes' );
        //     $('.result_currency').text('tonnes m'+decodeURI("%c3%a9")+'triques' );
        // }else{
        //     $('.result_currency').text('Verges carr'+decodeURI("%c3%a9")+'s' );
        // }
    }
}
function calculate(id, facteurM, facteurI){
    var input1 = document.getElementById("fieldA"+id).value;
    var input2 = document.getElementById("fieldB"+id).value;
    var input3 = (calculateArray[id] == "m" ? 1 : 39.36);

    if (document.getElementById("fieldC"+id)) {
        input3 = document.getElementById("fieldC"+id).value;
    }
    var result = 0;
    if (calculateArray[id] == "m") {
        result = input1*input2*input3*facteurM;
    } else if (facteurI > 3) {
        result = (input1/facteurI)*(input2/facteurI)*(input3/39.36)*facteurM;
    } else {
        result = input1*input2*(input3/12)*facteurI;
    }
    if(isNaN(result)){
        document.getElementById("fieldResult"+id).value= "R"+decodeURI("%C3%A9")+"sultat";
    } else {
        document.getElementById("fieldResult"+id).value = formatDecimals(result);
    }
}
function formatDecimals(value) {
    value = parseInt(value * 100);
    return parseFloat(value/100);
}

/*
 * FORMULAIRE
 */
function checkFields(){
    var requis = document.getElementsByClassName('requis');
    var valid = true;

    for(var i=0 ; i<requis.length ; i++){
        if(requis[i].value == ''){
            requis[i].classList.add('error_form');
            valid = false;
        }else{
        }
    }
    if(valid == true){
       ajaxForm2();
    }else{
        verfiy_input_error();
        return false;
    }
}


$(document).ready(function() {
  $('.values-item input').blur(function() {
      var t = $(this);
      var valItem = t.closest('.values-item');

      if (t.val().length != 0) {
          valItem.addClass('filled');
      } else {
          valItem.removeClass('filled');
      };
  })
});
